<template>
  <graph-detail34-template
    :board-ids="[114, 234, 235, 236, 237]"
    field-code="facility"
    :com-group-list="comGroupList"
    graph1-title="전체 (시설물) 관리 현황"
    graph2-title="월별 (시설물) 관리 현황"
    graph3-title="기간별 (시설물) 관리 현황"
    button-board="시설물 관리"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail34Template from "@/views/graph-detail/GraphDetail34Template.vue";

export default {
  name: "GraphDetail69",
  components: {
    GraphDetail34Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
